export default __webpack_public_path__ + "static/media/3.eaa08ae7.jpg";